module.exports = __webpack_public_path__ + "static/media/information_fill.a6c60de7.svg";